mutation DeleteAutomations($ids: [ID!]!) {
  deleteAutomations(ids: $ids) {
    id
  }
}
